<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span>{{ 'Details' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography py-2">
  <div class="row my-4 pb-1">
    @if (editorFields.length) {
      <div class="col-12 mb-4 section-group">
        <div class="section-title">
          <span>اطلاعات متنی (ویرایشگر)</span>
        </div>
        <div class="row">
          <div *ngFor="let field of editorFields"
               class="col-md-6 col-12 mb-3">
            <app-frontend-editor [(value)]="field.value"
                                 [required]="field.required || false"
                                 [title]="field.label"></app-frontend-editor>
          </div>
        </div>
      </div>
    }
    @if (fileChooserFields.length) {
      <div class="col-12 mb-4 section-group">
        <div class="section-title">
          <span>آیکون‌ها و فایل‌ها</span>
        </div>
        <div class="row">
          <div *ngFor="let field of fileChooserFields"
               class="col-md-6 col-12 mb-3">
            <app-frontend-file-chooser [(files)]="field.value"
                                       [isMultiple]="field.isMultiple || false"
                                       [required]="field.required || false"
                                       [title]="field.label"></app-frontend-file-chooser>
          </div>
        </div>
      </div>
    }
    @if (colorFields.length) {
      <div class="col-12 mb-4 section-group">
        <div class="section-title">
          <span>رنگ‌های سایت</span>
        </div>
        <div class="row">
          <div *ngFor="let field of colorFields"
               class="col-md-4 col-12 mb-3">
            <app-frontend-input [(value)]="field.value"
                                [required]="field.required || false"
                                [title]="field.label"
                                [type]="field.type"></app-frontend-input>
          </div>
        </div>
      </div>
    }
    @if (objectFields.length) {
      <div *ngFor="let objectField of objectFields"
           class="col-12 mb-4 section-group">
        <div class="section-title">
          <span>{{ objectField.label }}</span>
        </div>
        <div class="row">
          <div *ngFor="let field of objectField.objectFields"
               class="col-md-6 col-12 mb-3">
            @if (field.type === 'dropdown') {
              <app-frontend-dropdown [(value)]="field.value"
                                     [options]="field.options || []"
                                     [required]="field.required || false"
                                     [title]="field.label"></app-frontend-dropdown>
            }
            @if (field.type === 'checkbox') {
              <app-frontend-check-box [(value)]="field.value"
                                      [title]="field.label"></app-frontend-check-box>
            }
            @if (field.type === 'file-chooser') {
              <app-frontend-file-chooser [(files)]="field.value"
                                         [isMultiple]="field.isMultiple || false"
                                         [required]="field.required || false"
                                         [title]="field.label"></app-frontend-file-chooser>
            }
            @if (field.type === 'editor') {
              <app-frontend-editor [(value)]="field.value"
                                   [required]="field.required || false"
                                   [title]="field.label"></app-frontend-editor>
            }
            @if (field.type === 'color') {
              <app-frontend-input [(value)]="field.value"
                                  [required]="field.required || false"
                                  [title]="field.label"
                                  [type]="field.type"></app-frontend-input>
            }
            @if (field.type === 'input' || field.type === 'text' || field.type === 'number' || field.type === 'email' || field.type === 'password' || field.type === 'textarea') {
              <app-frontend-input [(value)]="field.value"
                                  [required]="field.required || false"
                                  [title]="field.label"
                                  [type]="field.type"></app-frontend-input>
            }
            @if (field.type === 'object') {
              <div class="col-12">
                <div class="sub-section-title mb-3">
                  <span>{{ field.label }}</span>
                </div>
                <div class="row">
                  <div *ngFor="let nestedField of field.objectFields"
                       class="col-md-6 col-12 mb-3">
                    @if (nestedField.type === 'dropdown') {
                      <app-frontend-dropdown [(value)]="nestedField.value"
                                             [options]="nestedField.options || []"
                                             [required]="nestedField.required || false"
                                             [title]="nestedField.label"></app-frontend-dropdown>
                    }
                    @if (nestedField.type === 'checkbox') {
                      <app-frontend-check-box [(value)]="nestedField.value"
                                              [title]="nestedField.label"></app-frontend-check-box>
                    }
                    @if (nestedField.type === 'file-chooser') {
                      <app-frontend-file-chooser [(files)]="nestedField.value"
                                                 [isMultiple]="nestedField.isMultiple || false"
                                                 [required]="nestedField.required || false"
                                                 [title]="nestedField.label"></app-frontend-file-chooser>
                    }
                    @if (nestedField.type === 'editor') {
                      <app-frontend-editor [(value)]="nestedField.value"
                                           [required]="nestedField.required || false"
                                           [title]="nestedField.label"></app-frontend-editor>
                    }
                    @if (nestedField.type === 'color') {
                      <app-frontend-input [(value)]="nestedField.value"
                                          [required]="nestedField.required || false"
                                          [title]="nestedField.label"
                                          [type]="nestedField.type"></app-frontend-input>
                    }
                    @if (nestedField.type === 'input' || nestedField.type === 'text' || nestedField.type === 'number' || nestedField.type === 'email' || nestedField.type === 'password' || nestedField.type === 'textarea') {
                      <app-frontend-input [(value)]="nestedField.value"
                                          [required]="nestedField.required || false"
                                          [title]="nestedField.label"
                                          [type]="nestedField.type"></app-frontend-input>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (arrayFields.length) {
      <div *ngFor="let field of arrayFields"
           class="col-12 mb-4 section-group">
        <div class="section-title d-flex justify-content-between align-items-center flex-wrap">
          <span>{{ field.label }}</span>
          <button (click)="addArrayItem(field)"
                  class="btn btn-sm btn-primary">
            <img src="/icons/add.svg"
                 style="width: 16px; height: 16px;">
            <span class="d-none d-md-inline">افزودن آیتم</span>
            <span class="d-md-none">افزودن</span>
          </button>
        </div>
        <div class="row">
          @if (field.value && field.value.length > 0) {
            <div *ngFor="let item of field.value; let i = index"
                 class="col-12 mb-3">
              <div class="array-item-container">
                <div class="array-item-header d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <span class="array-item-title">آیتم {{ i + 1 }}</span>
                  <button (click)="removeArrayItem(field, i)"
                          class="btn btn-sm btn-danger">
                    <img src="/icons/trash.svg"
                         style="width: 14px; height: 14px;">
                    <span class="d-none d-sm-inline">حذف</span>
                  </button>
                </div>
                <div class="row">
                  <div *ngFor="let arrayField of field.arrayFields"
                       class="col-md-6 col-12 mb-3">
                    @if (arrayField.type === 'dropdown') {
                      <app-frontend-dropdown [(value)]="item[arrayField.label]"
                                             [options]="arrayField.options || []"
                                             [required]="arrayField.required || false"
                                             [title]="arrayField.label"></app-frontend-dropdown>
                    }
                    @if (arrayField.type === 'checkbox') {
                      <app-frontend-check-box [(value)]="item[arrayField.label]"
                                              [title]="arrayField.label"></app-frontend-check-box>
                    }
                    @if (arrayField.type === 'file-chooser') {
                      <app-frontend-file-chooser [(files)]="item[arrayField.label]"
                                                 [isMultiple]="arrayField.isMultiple || false"
                                                 [required]="arrayField.required || false"
                                                 [title]="arrayField.label"></app-frontend-file-chooser>
                    }
                    @if (arrayField.type === 'editor') {
                      <app-frontend-editor [(value)]="item[arrayField.label]"
                                           [required]="arrayField.required || false"
                                           [title]="arrayField.label"></app-frontend-editor>
                    }
                    @if (arrayField.type === 'color') {
                      <app-frontend-input [(value)]="item[arrayField.label]"
                                          [required]="arrayField.required || false"
                                          [title]="arrayField.label"
                                          [type]="arrayField.type"></app-frontend-input>
                    }
                    @if (arrayField.type === 'input' || arrayField.type === 'text' || arrayField.type === 'number' || arrayField.type === 'email' || arrayField.type === 'password' || arrayField.type === 'textarea') {
                      <app-frontend-input [(value)]="item[arrayField.label]"
                                          [required]="arrayField.required || false"
                                          [title]="arrayField.label"
                                          [type]="arrayField.type"></app-frontend-input>
                    }
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="col-12">
              <div class="empty-array-message">
                <p>هیچ آیتمی اضافه نشده است. برای شروع روی "افزودن آیتم" کلیک کنید.</p>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (inputFields.length) {
      <div class="col-12 mb-4 section-group">
        <div class="section-title">
          <span>سایر تنظیمات</span>
        </div>
        <div class="row">
          <div *ngFor="let field of inputFields"
               class="col-md-6 col-12 mb-3">
            @if (field.type === 'dropdown') {
              <app-frontend-dropdown [(value)]="field.value"
                                     [options]="field.options || []"
                                     [required]="field.required || false"
                                     [title]="field.label"></app-frontend-dropdown>
            }
            @if (field.type === 'checkbox') {
              <app-frontend-check-box [(value)]="field.value"
                                      [title]="field.label"></app-frontend-check-box>
            }
            @if (field.type === 'input' || field.type === 'text' || field.type === 'number' || field.type === 'email' || field.type === 'password' || field.type === 'textarea') {
              <app-frontend-input [(value)]="field.value"
                                  [required]="field.required || false"
                                  [title]="field.label"
                                  [type]="field.type"></app-frontend-input>
            }
          </div>
        </div>
      </div>
    }
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (click)="onSubmitClicked()"
                           [Image]="true"
                           [class]="'card-main'"
                           [disabled]="false"
                           [src]="'./assets/icons/tick-square.svg'"
                           [title]="'Submit'">
      </app-frontend-button>
      <app-frontend-button (click)="noAction()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'./assets/icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
